export default class ItemRequiredModalCtrl {
  constructor ($scope, $mdDialog, WorkPlanModalSrv) {
  // constants
    const headData = WorkPlanModalSrv.getVariable()

    // variables
    $scope.itemOthersActivityRequired = headData.itemOthersActivityRequired
    $scope.itemAssignatures = headData.itemAssignatures
    $scope.itemListOtherActAM = headData.itemListOtherActAM

    // methods
    $scope.close = close
    $scope.toggleSubcategories = toggleSubcategories

    function close () {
      return $mdDialog.hide()
    }

    function toggleSubcategories (assignature) {
      if (assignature.showChilds) {
        assignature.showChilds = false
      } else {
        assignature.showChilds = true
      }
    }

  }
}

ItemRequiredModalCtrl.$inject = ['$scope', '$mdDialog', 'WorkPlanModalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/modals/itemRequiredModalCtrl.js